var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pen_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M836.2 191.1c-32.4-32.4-75.6-50.3-121.6-50.3S625.4 158.6 593 191L228.4 554.9c-4.5 4.5-7.9 10.2-9.8 16.3l-79.4 261.4c-4.1 13.7-.5 28.5 9.5 38.7 7.3 7.5 17.5 11.8 28 11.8 3.5 0 7-.5 10.4-1.4l268.1-74.3c6.5-1.8 12.5-5.3 17.2-10l363.9-363.2c67-66.9 67-176.1-.1-243.1zM424.3 734.8l-189.5 52.5 55.9-183.9 270.1-269.6 132.5 132.5-269 268.5zm356.6-355.9L748.7 411 616.3 278.5l32.1-32.1c17.6-17.7 41.2-27.4 66.2-27.4s48.6 9.7 66.2 27.4c36.6 36.6 36.6 96 .1 132.5z"
  })));
}

export default SvgPen;